export default function InstallationNoteService($http, appSettings) {
  'ngInject';
  this.createNote = function (installationId, note) {
    var endpoint = appSettings.InReachApiInstallationsEndpoint + '/' + installationId + '/notes';
    return $http.post(endpoint, note);
  };

  this.getInstallationNote = function (installationId) {
    return $http.get(appSettings.InReachApiInstallationsEndpoint + '/' + installationId + '/notes');
  };

  this.updateNote = function (installationId, noteId, note) {
    return $http.put(appSettings.InReachApiInstallationsEndpoint + '/' + installationId + '/notes' + '/' + noteId, note);
  };

  this.deleteNote = function (installationId, noteId) {
    return $http.delete(appSettings.InReachApiInstallationsEndpoint + '/' + installationId + '/notes' + '/' + noteId);
  };

  this.patchInstallationAttrs = function (installationId, changeset) {
    var endpoint = appSettings.InReachApiInstallationsEndpoint + '/' + installationId + '/attrs';
    return $http.patch(endpoint, changeset);
  };

}